module.exports = __webpack_public_path__ + "@/assets/img/welcome-banner.df2f2dd4.png";